export default __webpack_public_path__ + "static/tinyman-dcc9769850ef6210198adf1aaa616aa7.png";